/*
 * Copyright (c) 2021 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import React, { useContext } from 'react';
import launchLogo from '../assets/launch.svg';
import { BrandContext } from '../contexts/BrandContext';

const CustomLauncher = ({ handleToggle }) => {
  const { brand } = useContext(BrandContext);

  return (
    <button
      className="rcw-launcher"
      aria-label="Open chat"
      style={{
        color: brand.fontColor,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: `url(${launchLogo})`
      }}
      onClick={handleToggle}
    />
  );
};

export default CustomLauncher;
